import React from 'react';
import { Link } from 'react-router-dom';

import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { UpliftBetterHelpStackedIcon, UpliftBetterHelpStagingIcon } from '@uplift/icons';

const useStyles = makeStyles()(theme => ({
  icon: {
    height: '36px',
    width: 'auto',
    color: theme.palette.darkSlate.main,
  }
}));


export type NavigationLogoProps = {
  href?: string;
  variant?: 'default' | 'staging';
};


export const NavigationLogo: React.FC<NavigationLogoProps> = ({ href, variant = 'default' }) => {
  const { classes } = useStyles();

  const logo = variant === 'staging'
    ? <UpliftBetterHelpStagingIcon className={classes.icon} />
    : <UpliftBetterHelpStackedIcon className={classes.icon} />;

  if (href) {
    return (
      <Link to={href} style={{ display: 'flex', alignItems: 'center' }} data-testid="nav-logo-link">
        {logo}
      </Link>
    );
  }


  return (
    <Box display="flex" alignItems="center" data-testid="nav-logo">
      {logo}
    </Box>
  );
};
